module.exports = __webpack_public_path__ + "img/schema_selle_3a.874a61b7.svg";